import { render, staticRenderFns } from "./DevisSendModal.vue?vue&type=template&id=4cf88312"
import script from "./DevisSendModal.vue?vue&type=script&lang=js"
export * from "./DevisSendModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports